import { Button } from '@/components/ui/button.tsx';
import { authService } from '@/service/AuthService';
import { useTranslation } from 'react-i18next';

interface SignInButtonProps {
  asChild?: boolean;
}

const SignInButton = ({ asChild = false }: SignInButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="outline"
      onClick={() => authService.login()}
      className="relative flex h-10 md:min-w-32 border-2 border-indigo-700 rounded-3xl items-center justify-center overflow-hidden"
      asChild={asChild}
    >
      <span className="relative font-semibold text-md z-10">{t('button.signIn')}</span>
    </Button>
  );
};

export default SignInButton;
